import cartonIconUrl from '../../resources/carton-icon.png';

import { cn } from '../lib/cn';

export interface CartonIconProps {
    className?: string;
    /** Empty by default — Vivi is decorative when paired with text. Pass a
     *  non-empty alt only if Vivi is the sole signifier (rare). */
    alt?: string;
}

// Vivi mascot — the v2 assistant's friendly face. Shared across the singles
// wizard (welcome card, header, empty / error states) and the sidebar nav
// entry. Themable from the outside via `className` — pass `h-5 w-5`,
// `h-12 w-12`, etc.
export function CartonIcon({ className, alt = '' }: CartonIconProps) {
    return (
        <img
            src={cartonIconUrl}
            alt={alt}
            aria-hidden={alt === '' || undefined}
            draggable={false}
            className={cn('select-none', className)}
        />
    );
}
